import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  padding: 2em;
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.6;
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 1em;
`;

const Section = styled.section`
  margin-bottom: 2em;
`;

const SectionTitle = styled.h2`
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 1em;
  margin-top: 1.5em;
`;

const SubTitle = styled.h3`
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 0.5em;
`;

const Paragraph = styled.p`
  margin-bottom: 1em;
`;

const List = styled.ul`
  margin: 1em 0 1em 2em;
`;

const ListItem = styled.li`
  margin-bottom: 0.5em;
`;

const EffectiveDate = styled.p`
  font-style: italic;
  margin: 2em 0;
`;

const Email = styled.a`
  color: #ce0941;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

const PrivacyPolicyPage = () => {
  return (
    <Container>
      <Title>Privacy Policy</Title>
      <Paragraph>
        This privacy policy is applicable to the Adriatic Project app (hereinafter referred to as "Application") for
        mobile devices, which was developed by Betim Shala (hereinafter referred to as "Service Provider") as a Free
        service. This service is provided "AS IS".
      </Paragraph>

      <Section>
        <SectionTitle>What information does the Application obtain and how is it used?</SectionTitle>
        <SubTitle>User Provided Information</SubTitle>
        <Paragraph>
          The Application acquires the information you supply when you download and register the Application.
          Registration with the Service Provider is not mandatory. However, bear in mind that you might not be able to
          utilize some of the features offered by the Application unless you register with them.
        </Paragraph>
        <Paragraph>
          The Service Provider may also use the information you provided them to contact you from time to time to
          provide you with important information, required notices and marketing promotions.
        </Paragraph>
      </Section>

      <Section>
        <SubTitle>Automatically Collected Information</SubTitle>
        <Paragraph>
          In addition, the Application may collect certain information automatically, including, but not limited to, the
          type of mobile device you use, your mobile devices unique device ID, the IP address of your mobile device,
          your mobile operating system, the type of mobile Internet browsers you use, and information about the way you
          use the Application.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>Does the Application collect precise real time location information of the device?</SectionTitle>
        <Paragraph>
          This Application does not gather precise information about the location of your mobile device.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>Do third parties see and/or have access to information obtained by the Application?</SectionTitle>
        <Paragraph>
          Only aggregated, anonymized data is periodically transmitted to external services to aid the Service Provider
          in improving the Application and their service. The Service Provider may share your information with third
          parties in the ways that are described in this privacy statement.
        </Paragraph>
        <Paragraph>The Service Provider may disclose User Provided and Automatically Collected Information:</Paragraph>
        <List>
          <ListItem>as required by law, such as to comply with a subpoena, or similar legal process;</ListItem>
          <ListItem>
            when they believe in good faith that disclosure is necessary to protect their rights, protect your safety or
            the safety of others, investigate fraud, or respond to a government request;
          </ListItem>
          <ListItem>
            with their trusted services providers who work on their behalf, do not have an independent use of the
            information we disclose to them, and have agreed to adhere to the rules set forth in this privacy statement.
          </ListItem>
        </List>
      </Section>

      <Section>
        <SectionTitle>What are my opt-out rights?</SectionTitle>
        <Paragraph>
          You can halt all collection of information by the Application easily by uninstalling the Application. You may
          use the standard uninstall processes as may be available as part of your mobile device or via the mobile
          application marketplace or network.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>Data Retention Policy, Managing Your Information</SectionTitle>
        <Paragraph>
          The Service Provider will retain User Provided data for as long as you use the Application and for a
          reasonable time thereafter. The Service Provider will retain Automatically Collected information for up to 24
          months and thereafter may store it in aggregate. If you'd like the Service Provider to delete User Provided
          Data that you have provided via the Application, please contact them at betim.shala.7@outlook.com and we will
          respond in a reasonable time. Please note that some or all of the User Provided Data may be required in order
          for the Application to function properly.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>Children</SectionTitle>
        <Paragraph>
          The Service Provider does not use the Application to knowingly solicit data from or market to children under
          the age of 13. The Service Provider does not knowingly collect personally identifiable information from
          children. The Service Provider encourages all children to never submit any personally identifiable information
          through the Application and/or Services. The Service Provider encourage parents and legal guardians to monitor
          their children's Internet usage and to help enforce this Policy by instructing their children never to provide
          personally identifiable information through the Application and/or Services without their permission. If you
          have reason to believe that a child has provided personally identifiable information to the Service Provider
          through the Application and/or Services, please contact the Service Provider (betim.shala.7@outlook.com) so
          that they will be able to take the necessary actions. You must also be at least 16 years of age to consent to
          the processing of your personally identifiable information in your country (in some countries we may allow
          your parent or guardian to do so on your behalf).
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>Security</SectionTitle>
        <Paragraph>
          The Service Provider are concerned about safeguarding the confidentiality of your information. The Service
          Provider provide physical, electronic, and procedural safeguards to protect information we process and
          maintain. For example, we limit access to this information to authorized employees and contractors who need to
          know that information in order to operate, develop or improve their Application. Please be aware that,
          although we endeavor provide reasonable security for information we process and maintain, no security system
          can prevent all potential security breaches.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>Changes</SectionTitle>
        <Paragraph>
          This Privacy Policy may be updated from time to time for any reason. The Service Provider will notify you of
          any changes to the Privacy Policy by updating this page with the new Privacy Policy. You are advised to
          consult this Privacy Policy regularly for any changes, as continued use is deemed approval of all changes.
        </Paragraph>
        <EffectiveDate>This privacy policy is effective as of 2025-02-06</EffectiveDate>
      </Section>

      <Section>
        <SectionTitle>Your Consent</SectionTitle>
        <Paragraph>
          By using the Application, you are giving your consent to the Service Provider processing of your information
          as set forth in this Privacy Policy now and as amended by us. "Processing,” means using cookies on a
          computer/hand held device or using or touching information in any way, including, but not limited to,
          collecting, storing, deleting, using, combining and disclosing information.
        </Paragraph>
      </Section>
      <Section>
        <SectionTitle>Contact us</SectionTitle>
        <Paragraph>
          If you have any questions regarding privacy while using the Application, or have questions about the
          practices, please contact the Service Provider via email at{' '}
          <Email href="mailto:betim.shala.7@outlook.com">betim.shala.7@outlook.com</Email>.
        </Paragraph>
      </Section>
    </Container>
  );
};

export default PrivacyPolicyPage;
